<script lang="ts" setup>
import { KPlusChoosingFormModal, KPlusBuyFormModal, KPlusCostOfKitFormModal } from '@entities/kPlus/ui';

useHead({
  htmlAttrs: {
    lang: 'ru',
    prefix: 'og: http://ogp.me/ns#',
  },
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    {
      name: 'msapplication-TileColor',
      content: '#fff',
    },
    {
      name: 'msapplication-config',
      content: '/_4dk-main/browserconfig.xml',
    },
    {
      name: 'theme-color',
      content: '#fff',
    },
    {
      name: 'mobile-web-app-capable',
      content: 'yes',
    },
    {
      name: 'apple-mobile-web-app-status-bar-style',
      content: 'black-translucent',
    },
  ],
  link: [
    {
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com',
    },
    {
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: 'use-credentials',
    },
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap',
    },
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Mulish:ital,wght@0,200..1000;1,200..1000&display=swap',
    },
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap',
    },
    {
      rel: 'icon',
      href: '/_4dk-main/favicon.ico',
    },
    {
      rel: 'icon',
      type: 'image/svg+xml',
      href: '/_4dk-main/favicons/icon.svg',
    },
    {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: '/_4dk-main/favicons/apple-touch-icon.png',
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '32x32',
      href: '/_4dk-main/favicons/favicon-32x32.png',
    },
    {
      rel: 'icon',
      type: 'image/png',
      sizes: '16x16',
      href: '/_4dk-main/favicons/favicon-16x16.png',
    },
    {
      rel: 'manifest',
      href: '/_4dk-main/site.webmanifest',
    },
    {
      rel: 'mask-icon',
      href: '/_4dk-main/favicons/safari-pinned-tab.svg',
      color: '#1068bf',
    },
  ],
  script: [
    {
      innerHTML: `
        (function() {
          try {
            var STORAGE_KEY = 'userHistory';
            var currentUrl = location.href;
            var urls = [];
            
            if (!localStorage.getItem(STORAGE_KEY)) {
              var ref = document.referrer || 'direct';
              urls = [ref, currentUrl];
              localStorage.setItem(STORAGE_KEY, urls.join('\\n'));
            } else {
              urls = localStorage.getItem(STORAGE_KEY).split('\\n');
              if (urls[urls.length - 1] !== currentUrl) {
                urls.push(currentUrl);
                localStorage.setItem(STORAGE_KEY, urls.join('\\n'));
              }
            }
            
            var recordUrlChange = function() {
              var newUrl = location.href;
              if (urls[urls.length - 1] !== newUrl) {
                urls.push(newUrl);
                localStorage.setItem(STORAGE_KEY, urls.join('\\n'));
              }
            };
            
            var originalPushState = history.pushState;
            history.pushState = function() {
              originalPushState.apply(this, arguments);
              setTimeout(recordUrlChange, 10);
            };
            
            var originalReplaceState = history.replaceState;
            history.replaceState = function() {
              originalReplaceState.apply(this, arguments);
              setTimeout(recordUrlChange, 10);
            };
            
            window.addEventListener('popstate', function() {
              setTimeout(recordUrlChange, 10);
            });
          } catch (e) {
            console.error('Ошибка в SPA-трекере ссылок:', e);
          }
        })();
              `,
    },
    { src: 'https://api.mindbox.ru/scripts/v1/tracker.js', async: true, onload: 'window.__mindboxScriptLoaded = true' },
    {
      innerHTML: `mindbox = window.mindbox || function() { mindbox.queue.push(arguments); };
    mindbox.queue = mindbox.queue || [];
    mindbox("create", {
        endpointId: "4dk.Website"
    });`,
    },
    { src: 'https://mc.yandex.ru/metrika/watch.js' },
    {
      innerHTML: `
        (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
        m[i].l=1*new Date();
        for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
        k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
        (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym_35856070");
        try {
        var ym_35856070 = new Ya.Metrika({
          id:35856070,
          clickmap:true,
          webvisor:false,
          trackLinks:true,
          accurateTrackBounce:true,
          ecommerce:"dataLayer"
        });
        } catch(e) { }
      `,
    },
    {
      innerHTML: `(function (w, d, n, c) {
        w.CalltouchDataObject = n;
        w[n] = function () {
          w[n]['callbacks'].push(arguments);
        };
        if (!w[n]['callbacks']) {
          w[n]['callbacks'] = [];
        }
        w[n]['loaded'] = false;
        if (typeof c !== 'object') {
          c = [c];
        }
        w[n]['counters'] = c;
        for (var i = 0; i < c.length; i += 1) {
          p(c[i]);
        }

        function p(cId) {
          var a = d.getElementsByTagName('script')[0],
            s = d.createElement('script'),
            i = function () {
              a.parentNode.insertBefore(s, a);
            };
          s.async = true;
          s.src = 'https://mod.calltouch.ru/init.js?id=' + cId;
          if (w.opera == '[object Opera]') {
            d.addEventListener('DOMContentLoaded', i, false);
          }
          else {
            i();
          }
        }
      })(window, document, 'ct', 'lhv3x4tj');`,
    },
  ],
  noscript: [
    {
      innerHTML: `<div><img src="https://mc.yandex.ru/watch/35856070" style="position:absolute; left:-9999px;" alt="" /></div>`,
    },
  ],
});
</script>

<template>
  <div>
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <ClientOnly>
      <KPlusChoosingFormModal />
      <KPlusBuyFormModal />
      <KPlusCostOfKitFormModal />
    </ClientOnly>
  </div>
</template>
